/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Preferences_Channel_InappInputs */

const de_notifications_preferences_channel_inapp = /** @type {(inputs: Notifications_Preferences_Channel_InappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-App`)
};

/** @type {(inputs: Notifications_Preferences_Channel_InappInputs) => LocalizedString} */
const en_notifications_preferences_channel_inapp = de_notifications_preferences_channel_inapp;

/**

* @param {Notifications_Preferences_Channel_InappInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_channel_inapp = /** @type {((inputs?: Notifications_Preferences_Channel_InappInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Channel_InappInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_channel_inapp(inputs)
	return en_notifications_preferences_channel_inapp(inputs)
});